const updateHighlights = (state = {}, action) => {
    const { type = null, datasource } = action;

    if (type === 'dataEngine_update_response') {
        if (datasource === 'contentGraph') {
            const { highlightsByTypes : {
                condensedGame,
                gameRecap
            }} = action?.data || {};
            return {
                ...state,
                condensedGame,
                gameRecap,
            };
        }

        if (datasource === 'content') {
            const { highlightsByTypes : {
                condensedGame,
                gameRecap
            }, data: { tv } } = action?.data || {};
            return {
                ...state,
                condensedGame,
                gameRecap,
                tv
            };
        }
    }

    return state;
};

export default updateHighlights;
